import { gql } from "@apollo/client";
import { PERSON_FIELDS_FRAGMENT } from "../../../common/fieldsFragment";

export const GET_PERSON = gql`
  query GetPerson($personId: String!) {
    QR_GET_PERSON(personId: $personId) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        ...PersonFields
      }
    }
  }
  ${PERSON_FIELDS_FRAGMENT}
`;

export const ADD_PERSON_MUTATION = gql`
  mutation AddPerson($personInput: PersonInput!) {
    MT_ADD_PERSON(personInput: $personInput) {
      code
      data {
        id
        email
        type
      }
      error {
        message
        timestamp
        correlationId
      }
    }
  }
`;

export const UPDATE_PERSON_MUTATION = gql`
  mutation UpdatePerson($personId: String!, $personInput: PersonInput!) {
    MT_UPDATE_PERSON(personId: $personId, personInput: $personInput) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        ...PersonFields
      }
    }
  }
  ${PERSON_FIELDS_FRAGMENT}
`;

export const DELETE_PERSON_MUTATION = gql`
  mutation DeletePerson($personId: String!) {
    MT_DELETE_PERSON(personId: $personId) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        id
      }
    }
  }
`;

export const ACTIVATE_PERSON = gql`
  mutation ActivatePerson($personId: String!) {
    MT_ACTIVATE_PERSON(personId: $personId) {
      code
      data {
        id
      }
      error {
        message
      }
    }
  }
`;

export const addPerson = async (
  addPersonMutation,
  personInput,
  accessToken
) => {
  if (!personInput) {
    console.warn("addPerson ignoré : personInput est null ou undefined.");
    return;
  }

  try {
    const { loading, error, data } = await addPersonMutation({
      variables: { personInput },
      context: {
        headers: {
          authorization: accessToken ? `Bearer ${accessToken}` : "",
        },
      },
      fetchPolicy: "no-cache",
    });
    return { loading, error, data };
  } catch (error) {
    console.error("Erreur lors de la création de la personne :", error.message);
    throw error;
  }
};

export const updatePerson = async (
  updatePersonMutation,
  personId,
  personInput
) => {
  try {
    const { loading, error, data } = await updatePersonMutation({
      variables: {
        personId,
        personInput,
      },
    });
    return { loading, error, data };
  } catch (error) {
    console.error("Error creating user:", error.message);
    throw error;
  }
};

export const deletePerson = async (deletePersonMutation, personId) => {
  try {
    const { loading, error, data } = await deletePersonMutation({
      variables: { personId },
    });
    return { loading, error, data };
  } catch (error) {
    console.error("Erreur lors de la suppression de la personne :", error.message);
    throw error;
  }
};

export const activatePerson = async (
  activatePersonMutation,
  personId,
  accessToken
) => {
  try {
    const { loading, error, data } = await activatePersonMutation({
      variables: { personId },
      context: {
        headers: {
          authorization: accessToken ? `Bearer ${accessToken}` : "",
        },
      },
      fetchPolicy: "no-cache",
    });
    return { loading, error, data };
  } catch (error) {
    console.error("Erreur lors de l'activation de la personne :", error.message);
    throw error;
  }
};

export const UPDATE_USER_MUTATION = UPDATE_PERSON_MUTATION;
